import data from '../data/coin-history.json'
import articleData from "../data/financeFacts.json";
import FactsSection from "../components/FactsSection";
import AdComponent from "../components/AdComponent";
const CoinHistory = () => {

    const article = articleData?.PAGE3 || {};
    
    return(
        <>
            <section className="coin-history-section ">
                <div className="container"> 
                    <h2>Coins History</h2>
                    <div className="coin-history-cards">  
                        {
                            data.length > 0 ? 
                                data.map((transaction, index) => (
                                    <div className="coin-card" key={index}>
                                        <div className="coin-left">
                                            <img src={transaction.category_image ?? '/assets/images/card-7.png'} alt="Stock Exchange" />
                                        </div> 
                                        <div className="coin-center">
                                            <h4>{transaction.category_name ? transaction.category_name : transaction.source.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}</h4>
                                            <p>{transaction.created_at}</p>
                                        </div>
                                        <div className="coin-right">
                                            <span className="coin-status {transaction.transaction_type == 'credit' ? 'earned' : 'paid' ?>">{transaction.transaction_type == 'credit' ? 'Earned' : 'Paid'}</span>
                                            <div className="coin-value">
                                                <img src="/assets/images/coin.png" alt="coin" />
                                                <strong>{transaction.amount}</strong>
                                            </div>
                                        </div>
                                    </div> 
                                )) : 
                            <p className='mb-5'>No transactions found</p>
                        }
                    </div> 
                </div> 
            </section> 
            <AdComponent />
            <section className="facts-section">
                <div className="container">
                    <div className="finance-fact">
                        <h2 className="fw-bold mb-4">{article?.title}</h2>
                    </div>
                    {
                        article?.content?.map((item, index) => (
                            <FactsSection key={index} item={item} />
                        ))
                    }
                    <div className="article-card">
                        <h2 className="article-card-title">{article?.action?.title}</h2>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title1}</strong> {article?.action?.desc1}
                        </p>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title2}</strong> {article?.action?.desc2}
                        </p>
                        
                        <p className="article-card-desc">
                            {
                                article?.action?.list.map((list, index) => (
                                    <><span key={index}>{list}</span><br /></>
                                ))
                            }
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CoinHistory;